import { txCaptchaAppId } from '@/util/env'

export async function openCaptcha(callback, passstr = '') {
  new window.TencentCaptcha(txCaptchaAppId, callback, { userLanguage: 'zh-cn', bizState: passstr, needFeedBack: false }).show()
}

export function loadLoginSDK() {
  return new Promise((resolve, reject) => {
    if (typeof window.WxLogin === 'function') {
      resolve(window.WxLogin)
      return
    }
    const existing = document.querySelector('script[data-wx-login-sdk]')
    if (existing) {
      existing.addEventListener('load', () => resolve(window.WxLogin))
      existing.addEventListener('error', () => reject(new Error('微信登录脚本加载失败')))
      return
    }
    const script = document.createElement('script')
    script.src = 'https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js'
    script.async = true
    script.dataset.wxLoginSdk = '1'
    script.onload = () => resolve(window.WxLogin)
    script.onerror = () => reject(new Error('微信登录脚本加载失败'))
    document.body.appendChild(script)
  })
}
